import { useEffect, useRef } from "react";
import {
  useVideoControlActions,
  useVideoControlState,
} from "../contexts/VideoControlContext";

export const usePauseWhileOpen = (open: boolean): void => {
  const { isPlaying } = useVideoControlState();
  const { pause, play } = useVideoControlActions();
  const isPlayingRef = useRef(isPlaying);
  isPlayingRef.current = isPlaying;

  useEffect(() => {
    if (!open) return;
    const wasPlaying = isPlayingRef.current;
    pause();
    return () => {
      if (wasPlaying) play();
    };
  }, [open, pause, play]);
};
